<script>
import { GROUP_BY_OPTIONS } from '../../constants';
import FilterChip from './FilterChip.vue';

export default {
  name: 'ReportsFiltersDateGroupBy',
  components: { FilterChip },
  props: {
    validGroupOptions: {
      type: Array,
      default: () => [GROUP_BY_OPTIONS.DAY],
    },
    selectedOption: {
      type: Object,
      default: () => GROUP_BY_OPTIONS.DAY,
    },
  },
  emits: ['onGroupingChange'],
  data() {
    return {
      currentSelectedFilter: null,
    };
  },
  computed: {
    translatedOptions() {
      return this.validGroupOptions.map(option => ({
        ...option,
        groupBy: this.$t(option.translationKey),
      }));
    },
  },
  watch: {
    selectedOption: {
      handler() {
        this.currentSelectedFilter = {
          ...this.selectedOption,
          groupBy: this.$t(this.selectedOption.translationKey),
        };
      },
      immediate: true,
    },
  },
  methods: {
    changeFilterSelection(selectedFilter) {
      this.groupByOptions = this.$emit('onGroupingChange', selectedFilter);
    },
  },
};
</script>

<template>
  <FilterChip
    :model-value="currentSelectedFilter"
    :options="translatedOptions"
    label-key="groupBy"
    :prefix="$t('REPORT.GROUP_BY_FILTER_DROPDOWN_LABEL')"
    :placeholder="$t('REPORT.GROUP_BY_FILTER_DROPDOWN_LABEL')"
    icon="i-lucide-layers"
    :clearable="false"
    @update:model-value="changeFilterSelection"
  />
</template>
